<template>
  <div class="text-center">
    <vue-dropzone
      ref="myVueDropzone"
      id="dropzone"
      @vdropzone-success="vsuccess"
      :options="dropzoneOptions"
      :useCustomSlot="true"
      class="mt-2 p-3"
      style="border: dashed 1px"
    >
      <div class="dropzone-custom-content">
        <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
        <div class="subtitle">
          ...or click to select a file from your computer
        </div>
      </div>
    </vue-dropzone>
    <p>
      Download Sample Excel File
      <b-btn
        size="sm"
        variant="outline-info"
        @click="downloadSampleExcel"
      >
        <font-awesome-icon icon="file-excel" />
      </b-btn>
    </p>
    <b-button
      style="padding: 10px; color: white; background: #3ddc97; width: 86px"
      variant="outline-success"
      v-if="!uploading && !responseSuccess"
      @click="uploadFile"
    >Upload</b-button>
    <b-toast
      variant="danger"
      title="Bulk Upload"
      v-model="errorToast"
      solid
      append-toast
      auto-hide-delay="9000"
      v-for="(errorMsg,errorMsgIndex) in errorToastMsg"
      :key="errorMsgIndex"
    >
      <p v-html="sanitizeHtml(errorMsg)"></p>
    </b-toast>
  </div>
</template>
<script>
import VueDropzone from "../../../components/Dropzone/VueDropzone";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import { getAccessToken } from "@/utils/auth-requests";
export default {
  name: "BulkUploadEmployee",
  components: {
    VueDropzone,
  },
  data () {
    return {
      errorToast: false,
      errorToastMsg: [],
      showBulkUploadModal: false,
      uploading: false,
      isLoading: false,
      dropzoneOptions: {
        url: process.env.VUE_APP_API_URL + "api/v1/employees/rs/upload/" + localStorage.getItem( "userId" ),
        thumbnailWidth: 150,
        maxFilesize: 25,
        addRemoveLinks: true,
        autoProcessQueue: false,
        accept: ( file, done ) => {
          const name = file.name.toLowerCase();
          const dots = ( name.match( /\./g ) || [] ).length;

          if ( dots !== 1 ) {
            this.$bvToast.toast( this.$t( "upload.doubleExtensionMessage" ), {
              title: this.$t( "toast.title" ),
              variant: "danger",
              autoHideDelay: 8000,
              solid: true,
            } );
            return done( this.$t( "upload.invalidFileMessage" ) );
          }

          const extension = name.split( "." ).pop();
          if ( ![ "xlsx", "xls", "csv" ].includes( extension ) ) {
            this.$bvToast.toast( this.$t( "upload.invalidFileTypeMessage" ), {
              title: this.$t( "toast.title" ),
              variant: "danger",
              autoHideDelay: 8000,
              solid: true,
            } );
            return done( this.$t( "upload.invalidFileTypeMessage" ) );
          }
          done();
        },
      },
      submiting: false,
      responseSuccess: false,
    };
  },
  created () { },
  methods: {
    sanitizeHtml,
    vsuccess ( file, response ) {
      this.errorToastMsg = [];
      this.errorToast = false;
      this.uploading = false;
      this.submiting = false;
      this.responseSuccess = true;
      if ( response && response.status == 0 ) {
        this.errorToastMsg = response.excelErrors;
        this.errorToast = true;
      } else if ( response && response.status == 1 ) {
        this.$bvToast.toast(
          "Your bulk upload file has been successfully uploaded and is now processed",
          {
            title: "File Upload is complete",
            variant: "success",
            noAutoHide: false,
            appendToast: true,
          }
        );
      } else {
        this.$bvToast.toast(
          "File has not been uploaded successfully. Something went wrong!",
          {
            title: "Bulk Upload",
            variant: "danger",
            noAutoHide: false,
            appendToast: true,
          }
        );
      }
      this.clearAllData();
    },
    async uploadFile () {
      if ( this.$refs.myVueDropzone.getQueuedFiles().length > 0 ) {
        this.uploading = true;
        // Dropzone posts with its own XHR, so the axios interceptor never adds the token
        const accessToken = await getAccessToken( this.$store ) || localStorage.getItem( "accessToken" );
        this.$refs.myVueDropzone.setOption( "headers", {
          Authorization: "Bearer " + accessToken,
        } );
        this.$refs.myVueDropzone.processQueue();
      }
    },
    clearAllData () {
      this.uploading = false;
      this.submiting = false;
      this.responseSuccess = false;
      this.$refs.myVueDropzone.removeAllFiles();
    },

    downloadSampleExcel () {
      window.location.href = process.env.VUE_APP_API_URL + "/BulkUpload/Employee_Upload_Template.xlsx";
    },

  },
};
</script>